import React from "react";
import styled from "styled-components";
import uuid from "uuid/v4";

const RadioFlex = ({ name, value, disabled, onChange, defaultChecked, checked, children, ...props }) => {
  const randomID = uuid();

  return (
    <RadioContainer {...props}>
      <label htmlFor={randomID}>{children}</label>
      <input
        type="radio"
        name={name}
        id={randomID}
        value={value}
        disabled={disabled}
        onChange={onChange}
        defaultChecked={defaultChecked}
        checked={checked}
        {...props}
      />
      <span aria-hidden="true" />
    </RadioContainer>
  );
};

export default RadioFlex;

const RadioContainer = styled.div`
  display:flex;
  flex-direction:row-reverse;
  justify-content:flex-end;

  label {
    max-width:500px;
    font-size: 14px;
    line-height: 26px;
  }

`;
